import { request } from 'umi';
import type { Information, SearchParams, SearchPushRuleParams, HabitsParams, SavePushRuleParams, PublishStatus, StickStatusEnum } from './data';

export async function searchInfo(params: SearchParams) {
  return request('/hm/info/manage/pageSearch', {
    params
  })
};


export async function fetchInfoDetail(params: { id: string }) {
  return request('/hm/info/manage/detailInfo', {
    params
  })
};

export async function updateInfo(params: Partial<Information>) {
  return request('/hm/info/manage/editInfo', {
    method: 'POST',
    data: params
  })
};

//发布状态 1:已发表 2:未发表
export async function updPublishStatus(params: {infoId: number, publishStatus:string}) {
  return request('/hm/info/manage/updPublishStatus', {
    method: 'POST',
    params: params
  })
};



export async function fetchLabelList() {
  return request('/hm/info/manage/labelList')
};


export async function fetchChannelList() {
  return request('/hm/info/manage/channelList')
};

// 获取智能推送规则列表
export async function getPushRuleList(params: SearchPushRuleParams) {
  return request('/hm/smart-push/rule/page', {
    params,
  });
}

// 获取规则关联详情
export async function getPushRuleDetail(params: {id: number}) {
  return request('/hm/smart-push/detail', {
    params,
  });
}

// 获取通用健康习惯
export async function getHealthyHabits(params: HabitsParams) {
  return request('/hm/health/punch/items', {
    params,
  });
}

// 新增,设置智能推送规则
export async function savePushRuleSetting(params: SavePushRuleParams) {
  return request('/hm/smart-push/rule/save', {
    method: 'POST',
    data: params
  })
};

/** hm -- 资讯相关[HM端] -- 批量删除[B端]
 * POST /hm/info/manage/removeBatch
 * 接口地址：https://app.apifox.com/link/project/1822157/apis/api-91284655
 * @param {Array} body    资讯ids
 */
export async function batchRemoveInfoByIds(data: number[]) {
  return request('/hm/info/manage/removeBatch', {
    method: 'POST',
    data
  })
}

/** hm -- 资讯相关[HM端] -- 批量修改资讯推荐状态或发表状态
 * POST /hm/info/manage/updPublishStatusOrStickStatus
 * 接口地址：https://app.apifox.com/link/project/1822157/apis/api-91406466
 * @param {String} stickStatus    首页推荐状态 0:不推荐；1:推荐
 * @param {String} publishStatus  发布状态 1:已发表 2:未发表
 * @param {Array} body            资讯ids
 */
export async function batchUpdateInfoStatus(params: { stickStatus?: StickStatusEnum, publishStatus?: PublishStatus }, data: number[]) {
  return request('/hm/info/manage/updPublishStatusOrStickStatus', {
    method: 'POST',
    params,
    data
  })
}
